module.exports = __webpack_public_path__ + "img/user-example.d7dabd9f.svg";